<template>
  <div>
    <Row class="detail-header">
      <span>操作日志</span>
    </Row>
    <Row class="detail-form" style="padding-left:20px;">
      <Timeline>
        <TimelineItem v-for="(item, index) in logData" :key="index">
          <Icon slot="dot" type="ios-radio-button-on" :size="18" :color="styles.globalMainColor" />
          <div class="time">{{ item.operateTime.split('T')[0] }} {{ item.operateTime.split('T')[1] }}</div>
          <div class="content">
            <span style="margin-right: 8px;">{{ item.creatorName }}</span>
            <span>{{ item.content }}</span>
          </div>
        </TimelineItem>
      </Timeline>
    </Row>
  </div>
</template>

<script>
import styles from '@/assets/globalStyle.scss'
export default {
  props: {
    clueId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      styles: styles,
      logData: []
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      const url = '/business/clue-logs'
      const ajaxData = {
        clueId: this.clueId
      }
      this.$get(url, ajaxData).then(res => {
        if (res.code === 0 && res.data) {
          this.logData = res.data
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.time{
    font-size: 14px;
    font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/view/clue/myClue/plugin/clueLog.vue